module.exports = __webpack_public_path__ + "img/O2O-pic-01.05c8e5fa.png";